"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createFunctionEval;

var _isReserved = _interopRequireDefault(require("./isReserved"));

function createFunctionEval(name) {
  var fnName = (0, _isReserved.default)(name) ? "".concat(name, "$") : name; // eslint-disable-next-line no-new-func

  return new Function("return function ".concat(fnName, "() {}"))();
}